import { useState, useEffect, useCallback } from 'react';
import { admin as adminApi } from '../services/api';

const DOT = { active: 'var(--green)', inactive: 'var(--red,#e05)', unknown: 'var(--text3)' };

function SvcRow({ name, estado }) {
  const ok = estado === 'active';
  return (
    <div className="toggle-wrap" style={{ padding: '8px 0' }}>
      <div className="toggle-info">
        <div className="toggle-name" style={{ fontSize: '13px' }}>{name}</div>
        <div className="toggle-desc">{estado}</div>
      </div>
      <span style={{
        width: '10px', height: '10px', borderRadius: '50%',
        background: DOT[ok ? 'active' : 'inactive'],
        display: 'inline-block', flexShrink: 0,
      }} />
    </div>
  );
}

function Bar({ pct, warn = 80 }) {
  return (
    <div className="bar-track" style={{ height: '6px', marginTop: '6px' }}>
      <div style={{
        width: `${Math.min(pct, 100)}%`, height: '100%', borderRadius: '3px',
        background: pct >= warn ? 'var(--amber)' : 'var(--cyan)',
        transition: 'width .4s',
      }} />
    </div>
  );
}

export default function Health() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetch = useCallback(() => {
    adminApi.getHealth()
      .then(d => { setData(d); setLoading(false); setLastUpdate(new Date()); })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetch();
    const id = setInterval(fetch, 30000);
    return () => clearInterval(id);
  }, [fetch]);

  const webOk = data?.web?.status >= 200 && data?.web?.status < 300;

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Health Check</div>
          <div className="page-sub">Estado en tiempo real de devit.es</div>
        </div>
        <div className="topbar-actions">
          {lastUpdate && (
            <div style={{ fontSize: '11px', color: 'var(--text3)' }}>
              Actualizado {lastUpdate.toLocaleTimeString()} · refresca cada 30s
            </div>
          )}
        </div>
      </div>

      <div className="content">
        {loading ? (
          <div style={{ color: 'var(--text3)' }}>Cargando...</div>
        ) : !data ? (
          <div style={{ color: 'var(--amber)' }}>No se pudo conectar con el servidor.</div>
        ) : (
          <>
            {/* Métricas rápidas */}
            <div className="metrics">
              <div className={`metric ${webOk ? 'metric-green' : ''}`}>
                <div className="metric-label">Web devit.es</div>
                <div className="metric-value" style={{ fontSize: '18px' }}>
                  {webOk ? 'OK' : 'ERROR'}
                </div>
                <div className="metric-sub">HTTP {data.web.status} · {data.web.ms ?? '—'}ms</div>
              </div>
              <div className="metric metric-cyan">
                <div className="metric-label">RAM</div>
                <div className="metric-value">{data.ram.pct}%</div>
                <div className="metric-sub">{data.ram.usado_mb} / {data.ram.total_mb} MB</div>
              </div>
              <div className="metric">
                <div className="metric-label">Disco</div>
                <div className="metric-value">{data.disco.pct}%</div>
                <div className="metric-sub">{data.disco.usado_gb} / {data.disco.total_gb} GB</div>
              </div>
              <div className="metric">
                <div className="metric-label">Servicios</div>
                <div className="metric-value">
                  {Object.values(data.servicios).filter(s => s === 'active').length}
                  <span style={{ fontSize: '14px', color: 'var(--text3)' }}>
                    /{Object.keys(data.servicios).length}
                  </span>
                </div>
                <div className="metric-sub">activos</div>
              </div>
            </div>

            <div className="two-col" style={{ marginTop: '16px' }}>
              {/* Servicios */}
              <div className="card">
                <div className="card-title">Servicios systemd</div>
                {Object.entries(data.servicios).map(([name, estado]) => (
                  <SvcRow key={name} name={name} estado={estado} />
                ))}
              </div>

              {/* Recursos */}
              <div className="card">
                <div className="card-title">Recursos del servidor</div>
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                    <span style={{ color: 'var(--text2)' }}>RAM</span>
                    <span style={{ color: 'var(--text3)' }}>{data.ram.pct}%</span>
                  </div>
                  <Bar pct={data.ram.pct} />
                </div>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                    <span style={{ color: 'var(--text2)' }}>Disco</span>
                    <span style={{ color: 'var(--text3)' }}>{data.disco.pct}%</span>
                  </div>
                  <Bar pct={data.disco.pct} />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
